/**
 * Created by spepa on 10.04.2023
 */

let AchievementsConfig = [];

if (cleverapps.config.type === "merge") {
    AchievementsConfig = [
        {
            id: 0,
            type: Map2d.MERGE,
            title: "combomaster",
            amount: 17,
            kongId: "Combo Master",
            vkId: 4
        },
        {
            id: 1,
            type: "LEVEL_UP",
            title: "apprentice",
            level: 7,
            kongId: "Apprentice",
            vkId: 3
        },
        {
            id: 2,
            type: "LEVEL_UP",
            title: "apprenticenomore",
            level: 11,
            kongId: "Apprentice No More",
            vkId: 5
        },
        {
            id: 3,
            type: Map2d.OPEN_UNIT,
            title: "charactercollector",
            unit: { code: "king", stage: 3 },
            kongId: "Character Collector",
            vkId: 6
        },
        {
            id: 4,
            type: "FINISH_EXPEDITION",
            title: "greatexplorer",
            kongId: "Great Explorer",
            vkId: 7
        },
        {
            id: 5,
            type: Map2d.BUILD,
            title: "grandarchitect",
            castle: true,
            kongId: "Grand Architect",
            vkId: 8
        },
        {
            id: 6,
            type: "LEVEL_UP",
            title: "mergechampion",
            level: 34,
            kongId: "Merge Champion",
            vkId: 9
        }
    ];
}

if (cleverapps.config.type === "match3") {
    AchievementsConfig = [
        {
            id: 0,
            type: "PASS_LEVEL",
            title: "thirtyleveltriumph",
            level: 29,
            vkId: 21
        },
        {
            id: 1,
            type: "USE_MULTI_COLOR_CELL",
            title: "rainbowrush",
            vkId: 22
        },
        {
            id: 2,
            type: "OPEN_STAR_CHEST",
            title: "starchestsurprise",
            vkId: 23
        },
        {
            id: 3,
            type: "UPGRADE_HERO",
            title: "redherounleashed",
            hero: { color: "d", level: 1 },
            vkId: 24
        },
        {
            id: 4,
            type: "PASS_LEVEL",
            title: "level200achiever",
            level: 199,
            vkId: 25
        },
        {
            id: 5,
            type: "UPGRADE_HERO",
            title: "herocollector",
            allOpen: true,
            vkId: 26
        },
        {
            id: 6,
            type: "PASS_LEVEL",
            title: "level1000legend",
            level: 999,
            vkId: 27
        },
        {
            id: 7,
            type: "PASS_LEVEL",
            title: "level100",
            level: 100,
            onShelf: true
        },
        {
            id: 8,
            type: Achievements.VISIT_LOCATION,
            title: "start_nightparty",
            location: "nightparty",
            onShelf: true
        }
    ];
}

AchievementsConfig = AchievementsConfig.concat([
    { id: 10, unit: { code: "landmark", stage: 0 }, expedition: "undersea2" },
    { id: 11, unit: { code: "landmark", stage: 1 }, expedition: "rapunzel" },
    { id: 12, unit: { code: "landmark", stage: 2 }, expedition: "undersea" },
    { id: 13, unit: { code: "landmark", stage: 3 } },
    { id: 14, unit: { code: "landmark", stage: 4 } },
    { id: 15, unit: { code: "landmark", stage: 5 }, expedition: "rapunzel2" },
    { id: 16, unit: { code: "landmark", stage: 6 }, expedition: "dragonia" },
    { id: 17, unit: { code: "landmark", stage: 7 }, expedition: "dragonia2" },
    { id: 18, unit: { code: "landmark", stage: 8 } },
    { id: 19, unit: { code: "landmark", stage: 9 } },
    { id: 20, unit: { code: "landmark", stage: 10 } },
    { id: 21, unit: { code: "landmark", stage: 11 }, expedition: "dragonia3" },
    { id: 22, unit: { code: "landmark", stage: 12 } },
    { id: 23, unit: { code: "landmark", stage: 13 } },
    { id: 24, unit: { code: "landmark", stage: 14 } },
    { id: 25, unit: { code: "landmark", stage: 15 }, expedition: "rapunzel3" },
    { id: 26, unit: { code: "landmark", stage: 16 }, expedition: "adventure" },
    { id: 27, unit: { code: "landmark", stage: 17 }, expedition: "undersea3" },
    { id: 28, unit: { code: "landmark", stage: 18 } },
    { id: 29, unit: { code: "landmark", stage: 19 }, expedition: "adventure2" },
    { id: 30, unit: { code: "landmark", stage: 20 }, expedition: "blackfriday" },
    { id: 31, unit: { code: "landmark", stage: 21 }, expedition: "xmas" },
    { id: 32, unit: { code: "landmark", stage: 22 }, expedition: "china" },
    { id: 33, unit: { code: "landmark", stage: 23 }, expedition: "spring" },
    { id: 34, unit: { code: "landmark", stage: 24 }, expedition: "easter" },
    { id: 35, unit: { code: "landmark", stage: 25 }, expedition: "july4" },
    { id: 36, unit: { code: "landmark", stage: 26 }, expedition: "summerpets" },
    { id: 37, unit: { code: "landmark", stage: 27 }, expedition: "laborday" },
    { id: 38, unit: { code: "landmark", stage: 28 }, expedition: "startale" },
    { id: 39, unit: { code: "landmark", stage: 29 }, expedition: "adventure3" },
    { id: 40, unit: { code: "landmark", stage: 30 }, expedition: "halloween" },
    { id: 41, unit: { code: "landmark", stage: 31 }, expedition: "xmas" },
    { id: 42, unit: { code: "landmark", stage: 32 }, expedition: "blackfriday" },
    { id: 43, unit: { code: "landmark", stage: 33 }, expedition: "adventureny" },
    { id: 44, unit: { code: "landmark", stage: 34 }, expedition: "adventure4" },
    { id: 45, unit: { code: "landmark", stage: 35 }, expedition: "adventurevd" },
    { id: 46, unit: { code: "landmark", stage: 36 }, expedition: "china26" },
    { id: 47, unit: { code: "landmark", stage: 37 }, expedition: "patrickday" },
    { id: 48, unit: { code: "landmark", stage: 38 }, expedition: "easter26" },
    { id: 49, unit: { code: "landmark", stage: 39 }, expedition: "testadv" },
    { id: 50, unit: { code: "landmark", stage: 40 }, expedition: "earthday" },
    { id: 51, unit: { code: "landmark", stage: 41 }, expedition: "spring26" },
    { id: 52, unit: { code: "landmark", stage: 42 }, expedition: "nightparty" },
    { id: 53, unit: { code: "landmark", stage: 43 }, expedition: "graduation" },
    { id: 54, unit: { code: "landmark", stage: 44 }, expedition: "musicfest" },
    { id: 55, unit: { code: "landmark", stage: 45 }, expedition: "pirates" },
    { id: 56, unit: { code: "landmark", stage: 46 }, expedition: "candy" },
    { id: 57, unit: { code: "landmark", stage: 47 }, expedition: "laborday26" },
    { id: 58, unit: { code: "landmark", stage: 48 }, expedition: "autumn26" },
    { id: 59, unit: { code: "landmark", stage: 49 } },
    { id: 60, unit: { code: "landmark", stage: 50 } },
    { id: 61, unit: { code: "landmark", stage: 51 }, expedition: "detective26" },
    { id: 62, unit: { code: "landmark", stage: 52 }, expedition: "halloween26" },
    { id: 63, unit: { code: "landmark", stage: 53 }, expedition: "gnomes26" },
    { id: 64, unit: { code: "landmark", stage: 54 } },
    { id: 65, unit: { code: "landmark", stage: 55 } },
    { id: 66, unit: { code: "landmark", stage: 56 }, expedition: "xmas26" }
]);

AchievementsConfig.forEach((config) => {
    if (config.unit) {
        config.code = config.unit.code;
        config.stage = config.unit.stage;
        config.targetExpedition = config.targetExpedition || "main";
    }
});

AchievementsConfig.registerExpedition = function (expedition, data) {
    let config = this.find((c) => c.expedition === expedition);
    if (!config && data.id !== undefined) {
        // an expedition described by its design folder brings its landmark with it
        config = {
            unit: { code: "landmark", stage: data.stage }, code: "landmark", expedition
        };
        const next = this.findIndex((c) => c.id > data.id);
        this.splice(next === -1 ? this.length : next, 0, config);
    }
    if (config) {
        Object.assign(config, data);
        if (data.donors) {
            config.donors = cleverapps.toArray(data.donors);
        }
        config.targetExpedition = config.targetExpedition || "main";
    }
};

AchievementsConfig.listByExpedition = function (expedition) {
    return this.filter((config) => config.expedition === expedition && config.unit);
};

AchievementsConfig.listUnitAchievements = function () {
    return this.filter((config) => config.unit);
};

AchievementsConfig.findByExpedition = function (expedition) {
    return this.find((config) => config.expedition === expedition);
};

AchievementsConfig.findByUnit = function (unit) {
    return this.find((config) => config.unit && config.unit.code === unit.code && config.unit.stage === unit.stage);
};
